import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getCustomerContracts } from '../../customers'

export default function useCustomerContracts(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(
    ['customerContracts', query],
    () => getCustomerContracts(query)
  )
  return { data, error, isLoading }
}
